import React, { useEffect, useRef, useState, useContext } from "react";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

import Card from "../../../../Base/Components/Card/Card";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";

import { getEstantes } from "../../../../API/Suministros/SuministrosRequest";
import EstantesCrudModal from "./EstantesCRUD/EstantesCrudModal";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";

const EstanteScreen = ({ enModal = false }) => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [estantes, setEstantes] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);

  const getInfo = async () => {
    setLoading(true);
    const d = await getEstantes();
    // console.log(d);
    setEstantes(d);
    setLoading(false);
  };

  const columns = [
    {
      header: "ID",
      headerEn:"ID",
      field: "IdEstante",
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      header: "Nombre de Bodega",
      headerEn:"Warehouse Name",
      field: "NombreBodega",
      flex: 1,
      body: (e) => e?.NombreBodega,
      sort: 'asc'
    },
    {
      header: "Nombre de Estante",
      headerEn:"Shelf Name",
      field: "NombreEstante",
      flex: 1,
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      header: "Número de Estante",
      headerEn:"Shelf Number",
      field: "NumeroEstante",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      className: "small",
      Format: "Estado",  
      filter: false,   
      body: (rowData) => ({ ID: rowData.StatusName, Estado: rowData.StatusName }),
    },
    {
      header: "User Edit",
      headerEn: "User Edit",
      field: "UserCreate",
      hidden: userAuth.IdRol === 1,
      className: "large",
    },
    {
      field: "IdEstante",
      className: "",
      header: "",
      Format: "Botones",
      frozen: true,
      alignFrozen: "right",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: estantes,
    loading: loading,
  };


  useEffect(() => {
    setTitlePage(getLabel(baseLang, "estante", config.language));
    getInfo();
  }, []);

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "estante", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
                setSelected(null);
              }}
            />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: enModal ? "65vh" : "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />
      {showDialog && (
        <EstantesCrudModal
          toastRef={toast}
          estantesDialog={showDialog}
          estante={selected}
          setEstantesDialog={setShowDialog}
          getEst={getInfo}
          modo={selected ? "Editar" : "Crear"}
        />
      )}
    </div>
  );
};

export default EstanteScreen;
